export default __webpack_public_path__ + "static/media/joseph-gonzalez-bvteWf284Sw-unsplash.2fb9f387.jpg";